import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const humidity_BELOW: typeof valueTypeRenderers.humidity_BELOW = {
  label: () => unitConverter.humidityBelowCanopy().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.humidityBelowCanopy().title(),
      render: (n) => unitConverter.humidityBelowCanopy(n).valueAsString(),
    }),
}
